import {
  fromEvent
} from "./chunk.DLI4WUT3.js";
import {
  NoInnerEventsComponent
} from "./chunk.54YXW2TU.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  __decorateClass
} from "./chunk.U4VUMZVF.js";

// src/utilities/scrollable-component.ts
import { property, query } from "lit/decorators.js";
var ScrollableComponent = class extends NoInnerEventsComponent {
  constructor() {
    super(...arguments);
    this.reachedScrollEnd = false;
    this.infiniteScrollable = false;
    this.scrollEndOffset = 0;
  }
  firstUpdated() {
    this.observeScrollableElement();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unobserveScrollableElement();
  }
  observeScrollableElement() {
    this.updateComplete.then(() => {
      if (this.infiniteScrollable && this.scrollableElement) {
        const scrollableElementScroll = fromEvent(this.scrollableElement, "scroll");
        this.scrollSubscription = scrollableElementScroll.subscribe(this.handleScroll.bind(this));
      } else if (!this.scrollableElement) {
        console.error("Scrollable component should contain a scrollable element with `yotpo-scrollable-element` attribute!", this);
      }
    });
  }
  unobserveScrollableElement() {
    var _a;
    (_a = this.scrollSubscription) == null ? void 0 : _a.unsubscribe();
  }
  handleScroll() {
    if (!this.scrollableElement) {
      return;
    }
    const isScrollOverEndOffset = this.scrollableElement.offsetHeight + this.scrollableElement.scrollTop + this.scrollEndOffset >= this.scrollableElement.scrollHeight;
    if (isScrollOverEndOffset && !this.reachedScrollEnd) {
      this.reachedScrollEnd = true;
      emit(this, "yotpo-scroll-end" /* scrollEnd */);
    } else if (!isScrollOverEndOffset) {
      this.reachedScrollEnd = false;
    }
  }
  scrollToTop() {
    if (!this.scrollableElement) {
      return;
    }
    this.scrollableElement.scrollTop = 0;
  }
};
__decorateClass([
  query("[yotpo-scrollable-element]")
], ScrollableComponent.prototype, "scrollableElement", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], ScrollableComponent.prototype, "infiniteScrollable", 2);
__decorateClass([
  property({ type: Number, reflect: true })
], ScrollableComponent.prototype, "scrollEndOffset", 2);

export {
  ScrollableComponent
};
